// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kC","legalMessage":"kD","navLink":"kE","bottomLinkWrapper":"kF","bottomLink":"kG kE"};